import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { NgxCurrencyInputMode } from 'ngx-currency';

import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HiringService } from '../../hiring/services/hiring.service';
import { EmployeeService } from '../../employee/services/employee.service';

@Component({
  selector: 'app-direct-deposit',
  templateUrl: './direct-deposit.component.html',
  styleUrls: ['./direct-deposit.component.css'],
})
export class DirectDepositComponent implements OnInit {
  portalSettings: any;
  formData: { [key: string]: any } = {};
  lastSave: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  accountName: string[] = ['Primary', 'Secondary', 'Third', 'Fourth'];
  maxRouterNumber: number;
  invalidRouterCount: number;
  missAttachCount: number;
  currencySymbol: string;
  oNDDCustomText: any;
  accountList: any[] = [];
  fileData: any[] = [];
  errorMsg: string;
  duplicateAccount = false;
  totalPctOver100 = false;

  constructor(
    portalSettingsService: PortalSettingsService,
    private hiringService: HiringService,
    private employeeService: EmployeeService,
    private utilityService: UtilityService,
    public httpClient: HttpClient
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.maxRouterNumber =
      this.portalSettings.CountryDateCode.ConfigValue == 'CAN' ? 8 : this.portalSettings.CountryDateCode.ConfigValue == 'AU' ? 6 : 9;
    this.currencySymbol = '$'; //hardcode currency symbol on purpose as we have no prco here and the customer who request for symbol do not use onboarding?maybe?
    this.missAttachCount = 0;
    this.oNDDCustomText = this.portalSettings.ONDDCustomText.ConfigValue;
    this.getDirectDeposit();
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
  }

  getDirectDeposit(): void {
    this.hiringService.getOnboardDirectDepositsForOnboardee().then((response: any) => {
      if (response != null) {
        this.accountList = response;
        this.accountList.forEach((val: any) => {
          this.getAttachmentList(val);
          if (val.RoutingID == null) val.Invalid = true;
        });
        if (response.length == 0) this.addAccount();
      } else {
        this.errorMsg = response.Error;
      }
    });
  }

  saveDirectDeposit() {
    this.accountList.forEach((val: any, key: number) => {
      this.hiringService
        .saveOnboardDirectDeposit(
          val.OnboardDirectDepositID,
          key,
          val.RoutingID,
          val.BankAcct,
          val.Method,
          val.Amount,
          val.Pct != null ? parseFloat(val.Pct).toFixed(2) : null,
          val.AcctType
        )
        .then((response: any) => {
          this.fadeLabel(response.success);
        });
    });
  }

  checkAccount() {
    var tempAccount = {};
    this.duplicateAccount = false;
    this.accountList.forEach((val: any) => {
      if (val.BankAcct != null) {
        if (!tempAccount.hasOwnProperty(val.BankAcct)) {
          tempAccount[val.BankAcct] = 0;
        }
        tempAccount[val.BankAcct]++;
      }
    });

    for (const key in tempAccount) {
      const val = tempAccount[key];
      if (val > 1) {
        this.duplicateAccount = true;
      }
    }
  }

  resetValue(data: any) {
    data.Amount = null;
    data.Pct = null;
  }

  checkAllPct() {
    var tempTotal = 0;
    this.accountList.forEach((val: any) => {
      if (val.Pct != null) {
        tempTotal += parseFloat(val.Pct);
      }
    });
    this.totalPctOver100 = tempTotal > 100;
  }

  updatePercentage(amount: string, data: any) {
    data.Pct = amount;
  }

  addAccount() {
    this.hiringService.saveOnboardDirectDeposit(-1, this.accountList.length, null, null, null, null, null, null).then((response: any) => {
      if (response != null && response.success) {
        this.accountList.push({
          RoutingID: null,
          BankAcct: null,
          AcctType: null,
          Method: null,
          Amount: null,
          Pct: null,
          Attachments: null,
          OnboardDirectDepositID: response.OnboardDirectDepositID,
          Invalid: true,
        });
        this.missAttachCount++;
      }
    });
  }

  deleteOnboardDirectDeposit(data: any, index: number) {
    if (data.Attachments != null) {
      this.deleteAttachment(data);
    }
    this.hiringService.deleteOnboardDirectDeposit(data.OnboardDirectDepositID).then((response: any) => {
      if (response != null && response.success) {
        this.fadeLabel(response.success);
        this.accountList.splice(index, 1);
        this.missAttachCount--;
      }
    });
  }

  getAttachmentList(data: any) {
    var requestParam = 'moduleID=' + 601 + '&recordID=' + data.OnboardDirectDepositID + '&onboarding=' + true;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      if (response != null && response.length > 0) {
        data.Attachments = response[0];
      } else {
        this.missAttachCount++;
      }
    });
  }

  upload(data: any) {
    var file = data.Attachments;
    if (data.Attachments) {
      data.ErrorMsg = null;
      this.readFile(file[0], (e: any, filename: string) => {
        this.fileData = e.target.result.toString().split(',');
        if (data.Attachments.Progress != 100) {
          this.httpClient
            .request(
              new HttpRequest(
                'POST',
                '/Hiring/FileAttachmentSave',
                {
                  moduleID: 601,
                  recordID: data.OnboardDirectDepositID,
                  fileAttachData: this.fileData[1],
                  filename: this.utilityService.formatAttachmentName(filename),
                },
                {
                  reportProgress: true,
                }
              )
            )
            .subscribe(
              (event: HttpEvent<any>) => {
                switch (event.type) {
                  case HttpEventType.UploadProgress:
                    data.Attachments.Progress = Math.round((event.loaded / event.total) * 100);
                    if (data.Attachments.Progress == 100) {
                      data.Attachments.AttchDone = true;
                    }
                    break;
                  case HttpEventType.Response:
                    setTimeout(() => {
                      data.Attachments.result = event.body;
                      this.fadeLabel(event.body.success);
                      if (event.body.success) {
                        this.getAttachmentList(data);
                        this.missAttachCount--;
                      }
                    });
                }
              },
              error => (this.errorMsg = error.message)
            );
        }
      });
    }
  }

  deleteAttachment(data: any) {
    this.employeeService
      .removeFileAttachment(data.Attachments.FileAttachmentID)
      .then((response: any) => {
        if (response != null && response.success) {
          this.fadeLabel(response.success);
          data.Attachments = null;
          this.missAttachCount++;
        }
      })
      .catch((error: any) => {
        this.errorMsg = error?.error?.error ?? 'An error has occured';
      });
  }

  validateRouter(data: any) {
    this.invalidRouterCount = 0;
    var regex = new RegExp('^[0-9]{' + this.maxRouterNumber + '}$');

    if (!data.RoutingID || !data.RoutingID.match(regex)) {
      data.Invalid = true;
      this.invalidRouterCount++;
    } else {
      data.Invalid = false;
    }
  }

  readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = (e: any) => {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }
}
